var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeresearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6147 13.9368H9.56912C9.56912 12.7212 9.56912 11.5168 9.56912 10.3236C9.56912 9.13045 9.24956 8.76375 8.07965 8.75444C6.09368 8.73955 4.12215 8.75444 2.03868 8.75444V13.9218H0.0653516C0.0491028 13.6184 0.0166016 13.2926 0.0166016 12.9669C0.0166016 9.5232 0.0166016 6.08013 0.0166016 2.63768C0.0166016 1.09454 0.875985 0.0800424 2.36366 0.074458C4.67641 0.0651508 6.99277 0.130325 9.30372 0.23829C10.6 0.299718 11.4594 1.0927 11.5009 2.38642C11.5569 4.12315 11.9721 5.92316 11.0207 7.57613C10.9892 7.64052 10.9719 7.71128 10.97 7.78336C10.9682 7.85544 10.9818 7.92706 11.0099 7.99309C12.1184 9.87875 11.3132 11.9189 11.6147 13.9368ZM5.47622 6.79433V6.78128C6.4349 6.78128 7.39538 6.78128 8.35406 6.78128C9.17734 6.78128 9.55288 6.33457 9.5601 5.51181C9.5601 4.86216 9.57273 4.20875 9.57273 3.56469C9.57273 2.35102 9.35427 2.096 8.16269 2.07552C6.39517 2.04388 4.62587 2.07553 2.85835 2.0383C2.30409 2.02899 2.02063 2.18539 2.03688 2.81456C2.06576 3.89544 2.06576 4.97756 2.03688 6.06093C2.02063 6.63425 2.24631 6.81854 2.77891 6.80551C3.6726 6.77386 4.5717 6.79805 5.4708 6.79805L5.47622 6.79433Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeresearch);
export default __webpack_public_path__ + "static/media/timeresearch.73a832d04c59400544f840cffd37310d.svg";
export { ForwardRef as ReactComponent };